/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CommonDeletePayloadModel model module.
 * @module model/CommonDeletePayloadModel
 * @version v1.0.0
 */
class CommonDeletePayloadModel {
    /**
     * Constructs a new <code>CommonDeletePayloadModel</code>.
     * @alias module:model/CommonDeletePayloadModel
     * @param _delete {Boolean} delete status (required)
     * @param id {String} id (required)
     */
    constructor(_delete, id) { 
        
        CommonDeletePayloadModel.initialize(this, _delete, id);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, _delete, id) { 
        obj['delete'] = _delete;
        obj['id'] = id;
    }

    /**
     * Constructs a <code>CommonDeletePayloadModel</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CommonDeletePayloadModel} obj Optional instance to populate.
     * @return {module:model/CommonDeletePayloadModel} The populated <code>CommonDeletePayloadModel</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CommonDeletePayloadModel();

            if (data.hasOwnProperty('delete')) {
                obj['delete'] = ApiClient.convertToType(data['delete'], 'Boolean');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
        }
        return obj;
    }


}

/**
 * delete status (required)
 * @member {Boolean} delete
 */
CommonDeletePayloadModel.prototype['delete'] = undefined;

/**
 * id (required)
 * @member {String} id
 */
CommonDeletePayloadModel.prototype['id'] = undefined;






export default CommonDeletePayloadModel;

